import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { OrdersService } from '../../../../services/orders';
import { ActivatedRoute, Router } from '@angular/router';
import { Stockitem } from '../../../../interfaces/stockitem';
import { CartService } from '../../../../services/cart';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import Swal from 'sweetalert2';
import { DailyOfferStateService } from '../../../../services/dailyOfferState';
import { StockReviewService } from '../../../../services/stockreviewservice';
import { LoginService } from '../../../Authentication/auth/login.service';
import { UserService } from '../../../../services/user';


@Component({
  selector: 'app-productdetails',
  templateUrl: './productdetails.component.html',
  styleUrl: './productdetails.component.scss'
})
export class ProductdetailsComponent implements OnInit {

  contentReady = false;
  isMobile = false;
  isAr = false;
  avgRating = 0;
  ratingsCount = 0;

  comments: any[] = [];
  newComment = '';
  userStars = 0;

  // مثال user (عدّل حسب السيستم عندك)
  userId: any;
  productId: number[] = [];
  product!: Stockitem;

  brandname: any;
  branddisc: any;
  brandid: any;
  tokenExists = false;
  quantity = 0;
  showShare = false;
  product_id: any;
  private isBrowser: boolean;

  constructor(
    private router: Router,
    private _orderService: OrdersService,
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
    private _LoginService: LoginService,
    private cartService: CartService,
    private _userService: UserService,
    private _slugify: UrlSlugifyService,
    private stockReviewService: StockReviewService,
    public dailyOfferState: DailyOfferStateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {

    // language (browser only)
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }
    this.checkForToken();
    // 👇 listen to route param changes (NO reload)
    this.route.params.subscribe(params => {
      const id = Number(params['id']);

      this.loadProduct(id);

      // ⬆️ scroll to top
      if (this.isBrowser) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
  checkForToken(): void {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;
      try {
        this._userService.getUserId().subscribe({
          next: (data) => {
            this.userId = data.user_id;
          },
          error: (error) => {
            this.contentReady = false;
          },
        });
      } catch (e) {
        this.contentReady = false;
      }


    });
  }
  get roundedRating(): number {
    return Math.round(this.avgRating);
  }

  rateProduct(star: number): void {
    this.userStars = star;

    this.stockReviewService.addStar({
      stock_id: this.product.id,
      user_id: this.userId,
      stars: star
    }).subscribe(() => {
      Swal.fire({
        icon: 'success',
        title: this.isAr ? 'شكراً ' : 'Thank you!',
        text: this.isAr ? 'تم تسجيل تقييمك بنجاح' : 'Your rating has been saved',
        timer: 1500,
        showConfirmButton: false
      });

      this.loadProduct(this.product.id);
    });
  }
  addComment(): void {
    if (!this.newComment.trim()) return;

    this.stockReviewService.addComment({
      stock_id: this.product.id,
      user_id: this.userId,
      comment: this.newComment
    }).subscribe(() => {
      this.newComment = '';
      this.loadComments();
    });
  }

  // ================= LOAD PRODUCT =================
  private loadProduct(id: number): void {
    this.contentReady = true;
    this.productId = [id];

    this._orderService.getByIds(this.productId).subscribe({
      next: (data: any) => {
        this.contentReady = false;

        this.product = data[0];
        this.brandid = this.product.brand;

        this.loadComments();
        this.avgRating = this.product.ratings_avg_stars ?? 0;
        this.ratingsCount = this.product.ratings_count ?? 0;
        this.brandname = this.isAr
          ? this.product.brand?.brandname_ar
          : this.product.brand?.brandname_en;

        this.branddisc = this.isAr
          ? this.product.brand?.brand_description_ar
          : this.product.brand?.brand_description_en;

        // cart quantity (browser only)
        if (this.isBrowser) {
          this.quantity = this.cartService.getProductQuantity(this.product.id);
        }

        // SEO
        this.setSEO();
      },
      error: (err) => {
        console.error('Error fetching product:', err);
        this.contentReady = false;
      }
    });
  }
  loadComments(): void {
    this.stockReviewService
      .getCommentsByStock(this.product.id)
      .subscribe(res => {
        this.comments = res.comments;
      });
  }

  // ================= IMAGES =================
  fixImage(url: string): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }

  // ================= SEO =================
  setSEO(): void {
    if (!this.product) return;

    const productName = this.isAr
      ? this.product.name_ar
      : this.product.name_en;

    const brandName = this.brandname;
    const price = this.product.pricea;
    const image = this.fixImage(this.product.image);

    const slug = this._slugify.slugify(this.product.name_en);
    const url = `https://bboxmart.com/product/${slug}/${this.product.id}`;

    this.title.setTitle(`${productName} | ${brandName} | Bluebox Mart`);

    this.meta.updateTag({
      name: 'description',
      content: `${productName} from ${brandName}. Buy now for ${price} EGP with fast delivery & 5% cashback from Bluebox Mart.`
    });

    this.meta.updateTag({ property: 'og:type', content: 'product' });
    this.meta.updateTag({ property: 'og:title', content: productName });
    this.meta.updateTag({
      property: 'og:description',
      content: `Buy ${productName} for ${price} EGP. Fast delivery & trusted shopping from Bluebox Mart.`
    });
    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:site_name', content: 'Bluebox Mart' });

    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: productName });
    this.meta.updateTag({
      name: 'twitter:description',
      content: `Buy now for ${price} EGP with fast delivery.`
    });
    this.meta.updateTag({ name: 'twitter:image', content: image });

    if (this.isBrowser) {
      this.setCanonical(url);
    }
  }

  private setCanonical(url: string): void {
    let link = document.querySelector("link[rel='canonical']") as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    link.setAttribute('href', url);
  }

  // ================= PRICE =================
  calcDis(newP: any, oldP: any): number | null {
    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / oldP) * 100);
    return isNaN(off) ? null : off;
  }

  // ================= CART =================
  plus(product: any): void {
    if (!this.isBrowser) return;
    this.cartService.addToCart(product);
    this.quantity = this.cartService.getProductQuantity(product.id);
  }

  min(product: any): void {
    if (!this.isBrowser) return;
    const currentQty = this.cartService.getProductQuantity(product.id);
    if (currentQty > 0) {
      this.cartService.removeFromCart(product);
      this.quantity = this.cartService.getProductQuantity(product.id);
    }
  }

  addToCart(product: any): void {
    if (!this.isBrowser) return;
    this.cartService.addToCart(product);
  }

  removeFromCart(product: any): void {
    if (!this.isBrowser) return;
    this.cartService.removeFromCart(product);
  }

  // ================= NAVIGATION =================
  bybrand(brand: any): void {
    this.router.navigate([
      '/brand',
      this._slugify.slugify(brand.brandname_en),
      brand.id
    ]);
  }

  // ================= SHARE =================
  toggleShare(): void {
    this.showShare = !this.showShare;
  }

  buildShareUrl(): string {
    return `https://product.bboxmart.com/share/${this.product.id}`;
  }

  shareFacebook(): void {
    if (!this.isBrowser) return;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  shareWhatsApp(): void {
    if (!this.isBrowser) return;
    window.open(
      `https://wa.me/?text=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  shareTelegram(): void {
    if (!this.isBrowser) return;
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  // ================= COPY LINK =================
  copyShareLink(): void {
    if (!this.isBrowser) return;

    const url = this.buildShareUrl();

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(() => {
        this.showCopied();
      }).catch(() => {
        this.fallbackCopy(url);
      });
    } else {
      this.fallbackCopy(url);
    }
  }

  private fallbackCopy(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      this.showCopied();
    } catch (err) {
      console.error('Copy failed', err);
    }

    document.body.removeChild(textarea);
  }

  private showCopied(): void {
    Swal.fire({
      icon: 'success',
      title: this.isAr ? 'تم النسخ!' : 'Copied!',
      text: this.isAr ? 'تم نسخ الرابط' : 'Link copied to clipboard',
      timer: 1200,
      showConfirmButton: false
    });
  }
}
